import {Component, Injector, OnInit} from '@angular/core';
import { multiTwoBar, singleCategory, multiLine } from '../Models/chart-model.model';
import {PomodoroRepository} from '../Models/PomodoroRepository';
import {TaskService} from '../services/task.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SnackBarService} from '../services/snack-bar.service';
import {ChartService} from '../services/chart.service';

@Component({
  selector: 'app-chart-statistics',
  templateUrl: './chart-statistics.component.html',
  styleUrls: ['./chart-statistics.component.css']
})
export class ChartStatisticsComponent implements OnInit {
  public pomodoroRepository: PomodoroRepository;
  public multiTwoBar: any[];
  public viewTwoBar: any[] = [1000, 400];
  public convert: any[];
  // options
  public showXAxisTwoBar = true;
  public showYAxisTwoBar = true;
  public showLegendTwoBar = true;
  public showXAxisLabelTwoBar = true;
  public xAxisLabelTwoBar = 'روز های هفته';
  public showYAxisLabelTwoBar = true;
  public yAxisLabelTwoBar = 'ساعت';
  public colorSchemeTwoBar = {
    domain: ['#fd466c', '#dc143c', '#AAAAAA']
  };
  public singleCategory: any[];
  public viewCategory: any[] = [1000, 400];
  public gradientCategory = true;
  public showLegendCategory = true;
  public showLabelsCategory = true;
  public isDoughnutCategory = false;
  public legendPositionCategory = 'below';

  public colorSchemeCategory = {
    domain: ['#fd466c', '#dc143c', '#ca1340', '#860303']
  };
  public multiLine: any[];
  public viewLine: any[] = [1000, 300];

  // options
  public legendLine = true;
  public showLabelsLine = true;
  public animationsLine = true;
  public xAxisLine = true;
  public yAxisLine = true;
  public showYAxisLabelLine = true;
  public showXAxisLabelLine = true;
  public xAxisLabelLine = 'ماه های سال';
  public yAxisLabelLine = 'جمع ساعات';
  public timelineLine = true;

  public colorSchemeLine = {
    domain: ['#dc143c']
  };
  constructor(private injector: Injector,
              private taskService: TaskService,
              private snackBar: MatSnackBar,
              private snackBarService: SnackBarService,
              private chartService: ChartService) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
    Object.assign(this, { multiTwoBar });
    Object.assign(this, { singleCategory });
    Object.assign(this, { multiLine });
  }

  ngOnInit(): void {
    this.getBarCharts();
  }

  onSelectTwoBar(data): void {
    // console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivateTwoBar(data): void {
    // console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivateTwoBar(data): void {
    // console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
  onSelectCategory(data): void {
    // console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivateCategory(data): void {
    // console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivateCategory(data): void {
    // console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
  onSelectLine(data): void {
    // console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivateLine(data): void {
    // console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivateLine(data): void {
    // console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
  // getBarChart(): any{
  //   this.chartService.getBarWeeklyChart().subscribe(
  //     (data) => {
  //       this.thisWeek = data.data;
  //       console.log(this.thisWeek);
  //     }
  //   );
  // }
  getBarCharts(): any{
    this.chartService.getBarWeeklyChart().subscribe(
      (data) => {
        this.convert = data.data;
        console.log(this.convert);
        console.log(this.multiTwoBar);
      }
    );
  }
}
